import { handleResponse, handleError } from "../apiUtils";
import { BASE_URL } from "../../utils/connectApi";
import axios from "axios";

export function verifyUser({ token }) {
  let config = {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetch(BASE_URL + "/user", config)
    .then(handleResponse)
    .catch(handleError);
}

export const signup = (credentials) => {
  return axios({
    url: `${BASE_URL}signup`,
    method: "POST",
    data: credentials,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
export const signin = (credentials) => {
  return fetch(`${BASE_URL}signin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      email: credentials.userName,
    }),
  });
};

export const authenticate = (credentials) => {
  const { userName, password } = credentials;
  return axios
    .request({
      url: `${BASE_URL}/authenticate`,
      method: "POST",
      credentials,
    })
    .then((response) => {
      console.log("response from authentication", response);
      return response;
    });
};

export const getMyProfile = (token) => {
  return axios.request({
    url: `${BASE_URL}/myProfile`,
    method: "GET",
    header: {
      "access-headers": token || "foo",
    },
  });
};

export const getUser = (userName) => {
  return axios.request({
    url: `${BASE_URL}/getUser`,
    method: "POST",
    data: {
      userName,
    },
  });
};
